import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const pricingData = [
  {
    service: '名刺制作',
    detail: 'デザイン＋印刷 100枚',
    price: '6,600円〜',
  },
  {
    service: '名刺制作',
    detail: '印刷のみ 100枚',
    price: '2,200円〜',
  },
  {
    service: 'チラシ制作',
    detail: 'デザイン＋印刷 100枚',
    price: '21,200円〜',
  },
  {
    service: 'チラシ制作',
    detail: 'デザインのみ',
    price: '15,400円〜',
  },
  {
    service: 'ホームページ制作',
    detail: 'HTML/CSS/JS、スマホ対応',
    price: '200,000円〜',
  },
  {
    service: '保守・管理',
    detail: '月額（ドメイン・サーバー維持、軽微な修正）',
    price: '6,000円〜',
  },
  {
    service: '動画制作',
    detail: 'SNS向け短尺動画・企業紹介等',
    price: '都度お見積り（内容・尺により変動）',
  },
  {
    service: 'BPO・事務サポート',
    detail: 'データ入力・書類スキャン等',
    price: '都度お見積り（作業量により変動）',
  },
];

export default function Pricing() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      
      <section className="pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-6">
                Price Guide
              </span>
              <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
                料金の目安
              </h1>
              <div className="bg-accent-50 border border-accent-200 rounded-xl p-4 md:p-6">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  表示価格はすべて<strong className="text-foreground-950">税込</strong>です。最終金額は内容・ボリュームにより異なります。まずは無料ヒアリング（30分）でお見積りください。
                </p>
              </div>
            </div>

            {/* Pricing Table */}
            <div className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-background-100 border-b border-background-200">
                      <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">サービス</th>
                      <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">内容</th>
                      <th className="text-right px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">目安（税込）</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pricingData.map((item, idx) => (
                      <tr
                        key={idx}
                        className={`border-b border-background-200/60 ${
                          idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                        } hover:bg-accent-50/50 transition-colors`}
                      >
                        <td className="px-6 py-4 text-foreground-900 font-medium whitespace-nowrap">
                          {item.service}
                        </td>
                        <td className="px-6 py-4 text-foreground-600">
                          {item.detail}
                        </td>
                        <td className="px-6 py-4 text-right text-foreground-950 font-bold text-base whitespace-nowrap">
                          {item.price}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-10">
              <div className="bg-accent-50 border border-accent-200 rounded-xl p-4 md:p-5 mb-10">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  表示価格はすべて<strong className="text-foreground-950">税込</strong>。お支払いは個別契約に基づき銀行振込またはクレジットカード（決済代行経由）となります。
                </p>
              </div>
              <p className="text-foreground-600 mb-6">
                まずは無料ヒアリングであなたのニーズをお聞かせください。
              </p>
              <Link
                to="/contact"
                className="inline-block px-8 py-4 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                無料相談はこちら
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}